module.exports = __webpack_public_path__ + "img/account_back.32dcf2ab.png";